"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Omit = void 0;
const FlagFromLog_1 = require("./FlagFromLog");
function Omit() {
    return FlagFromLog_1.FlagFromLog("omit");
}
exports.Omit = Omit;
//# sourceMappingURL=Omit.js.map